// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__wqti-","label":"Cell_label__VUHBF","action":"Cell_action__RWQsB"};